<template>
  <div>
    <!-- 微信框设置区域 -->
    <div id="app-menu">
      <!-- 预览窗 -->
      <div class="weixin-preview">
        <div class="weixin-bd">
          <div class="weixin-header">公众号菜单</div>
          <ul class="weixin-menu" id="weixin-menu">
            <li class="menu-items"><a-icon type="menu" /></li>
            <li
              v-for="(btn, i) in menu.buttons"
              :key="i"
              class="menu-item"
              :class="{
                current: selectedMenuIndex === i && selectedMenuLevel == 1,
              }"
              @click="selectMenu(i)"
            >
              <div class="menu-item-title">
                <span>{{ btn.name }}</span>
              </div>
              <ul class="weixin-sub-menu">
                <li
                  v-for="(sub, i2) in btn.subButtons"
                  :key="i2"
                  class="menu-sub-item"
                  :class="{
                    current:
                      selectedMenuIndex === i &&
                      selectedSubMenuIndex === i2 &&
                      selectedMenuLevel == 2,
                    'on-drag-over': onDragOverMenu == i + '_' + i2,
                  }"
                  @click.stop="selectSubMenu(i, i2)"
                  draggable="true"
                  @dragstart="selectSubMenu(i, i2)"
                  @dragover.prevent="onDragOverMenu = i + '_' + i2"
                  @drop="onDrop(i, i2)"
                >
                  <div class="menu-item-title">
                    <span>{{ sub.name }}</span>
                  </div>
                </li>
                <li
                  v-if="btn.subButtons.length < 5"
                  class="menu-sub-item"
                  :class="{
                    'on-drag-over':
                      onDragOverMenu == i + '_' + btn.subButtons.length,
                  }"
                  @click.stop="addMenu(2, i)"
                  @dragover.prevent="
                    onDragOverMenu = i + '_' + btn.subButtons.length
                  "
                  @drop="onDrop(i, btn.subButtons.length)"
                >
                  <div class="menu-item-title">
                    <a-icon type="plus" />
                  </div>
                </li>
                <i class="menu-arrow arrow_out"></i>
                <i class="menu-arrow arrow_in"></i>
              </ul>
            </li>
            <li
              class="menu-item"
              v-if="menu.buttons.length < 3"
              @click="addMenu(1)"
            >
              <a-icon type="plus" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 菜单编辑器 -->
      <div class="weixin-menu-detail" v-if="selectedMenuLevel > 0">
        <wx-menu-button-editor
          :button="selectedButton"
          :selectedMenuLevel="selectedMenuLevel"
          :wechatAppId="queryParam.appid"
          :pageTotal="pageTotal"
          @delMenu="delMenu"
        ></wx-menu-button-editor>
      </div>
    </div>
    <div class="weixin-btn-group">
      <a-button type="primary" icon="upload" @click="updateWxMenu"
        >发布</a-button
      >
      <a-button type="danger" icon="delete" @click="delMenu">清空</a-button>
    </div>
  </div>
  <!-- 微信框设置区域END -->
</template>

<script>
import '@/assets/less/TableExpand.less';
import { getAction, postAction } from '@/api/manage';
export default {
  name: 'wxMenu',
  components: {
    wxMenuButtonEditor: () => import('./menuButton'),
  },
  data() {
    return {
      isAdd: false,
      description: '菜单设置页面',
      queryParam: {},
      wechatAppId: '',
      wechatApp: [],
      wechatMiniApp: [],
      wechatMiniAppPath: [],
      dictOptions: {},
      pageTotal: {},
      menu: { buttons: [] }, //当前菜单
      selectedMenuIndex: '', //当前选中菜单索引
      selectedSubMenuIndex: '', //当前选中子菜单索引
      selectedMenuLevel: 0, //选中菜单级别
      selectedButton: '', //选中的菜单按钮
      onDragOverMenu: '', //当前鼠标拖动到的位置
    };
  },
  mounted() {
    this.getMenu();
    this.getWechatApp();
  },
  computed: {},
  methods: {
    initDictConfig() {},
    handleChange(value) {
      this.queryParam.appid = value;
      this.getMenu();
      this.getPageCount();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2',
      }).then((res) => {
        if (res.success) {
          this.wechatApp = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getPageCount() {
      if (this.$route.query.id != null) {
        this.wechatAppId = this.$route.query.id;
      }
      getAction(
        process.env.VUE_APP_CMS_WECHAT + `/wechat/material/materialCount`,
        { appId: this.wechatAppId }
      ).then((res) => {
        if (res.success) {
          this.pageTotal = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getMenu() {
      if (this.$route.query.id != null) {
        this.wechatAppId = this.$route.query.id;
        this.queryParam.appid = this.$route.query.id;
      } else {
        this.wechatAppId = this.queryParam.appid;
      }
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatMenu/getMenu', {
        appId: this.wechatAppId,
      }).then((res) => {
        if (res.success) {
          this.$route.query.id = null;
          this.menu = res.result.menu;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //选中主菜单
    selectMenu(i) {
      console.log(this.isAdd);
      if (this.isAdd === true) {
        this.$message.warning('请先发布或清空！');
      } else {
        this.selectedMenuLevel = 1;
        this.selectedSubMenuIndex = '';
        this.selectedMenuIndex = i;
        this.selectedButton = this.menu.buttons[i];
      }
    },
    //选中子菜单
    selectSubMenu(i, i2) {
      console.log(this.isAdd);
      if (this.isAdd === true) {
        this.$message.warning('请先发布或清空！');
      } else {
        this.selectedMenuLevel = 2;
        this.selectedMenuIndex = i;
        this.selectedSubMenuIndex = i2;
        this.selectedButton = this.menu.buttons[i].subButtons[i2];
      }
    },
    //添加菜单
    addMenu(level, i) {
      console.log(this.isAdd);
      if (this.isAdd === true) {
        this.$message.warning('请先发布或清空！');
      } else {
        if (level == 1 && this.menu.buttons.length < 3) {
          this.menu.buttons.push({
            type: 'view',
            name: '菜单名称',
            subButtons: [],
            url: '',
          });
          this.selectMenu(this.menu.buttons.length - 1);
          this.isAdd = true;
        }
        if (level == 2 && this.menu.buttons[i].subButtons.length < 5) {
          this.menu.buttons[i].subButtons.push({
            type: 'view',
            name: '子菜单名称',
            url: '',
          });
          this.selectSubMenu(i, this.menu.buttons[i].subButtons.length - 1);
          this.isAdd = true;
        }
      }
    },
    //删除菜单
    delMenu() {
      this.isAdd = false;
      if (
        this.selectedMenuLevel == 1 &&
        confirm('删除后菜单下设置的内容将被删除')
      ) {
        this.menu.buttons.splice(this.selectedMenuIndex, 1);
        this.unSelectMenu();
      } else if (this.selectedMenuLevel == 2) {
        this.menu.buttons[this.selectedMenuIndex].subButtons.splice(
          this.selectedSubMenuIndex,
          1
        );
        this.unSelectMenu();
      }
    },
    unSelectMenu() {
      //不选中任何菜单
      this.selectedMenuLevel = 0;
      this.selectedMenuIndex = '';
      this.selectedSubMenuIndex = '';
      this.selectedButton = '';
    },
    updateWxMenu() {
      let isUrl = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/
      for (let i = 0; i < this.menu.buttons.length; i++) {
        console.log(!isUrl.test(this.menu.buttons[i].url));
        if (!isUrl.test(this.menu.buttons[i].url) || this.menu.buttons[i].url == '') {
          return this.$message.warning('请输入正确的页面地址！');
        }
      }
      this.$http({
        url: process.env.VUE_APP_CMS_WECHAT + '/wechatMenu/updateMenu',
        params: { appId: this.queryParam.appid },
        data: this.menu,
        method: 'post',
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success('操作成功');
          this.isAdd = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onDrop(i, i2) {
      //拖拽移动位置
      this.onDragOverMenu = '';
      if (i == this.selectedMenuIndex && i2 == this.selectedSubMenuIndex)
        //拖拽到了原位置
        return;
      if (
        i != this.selectedMenuIndex &&
        this.menu.buttons[i].subButtons.length >= 5
      ) {
        this.$message.error('目标组已满');
        return;
      }
      this.menu.buttons[i].subButtons.splice(i2, 0, this.selectedButton);
      let delSubIndex = this.selectedSubMenuIndex;
      if (i == this.selectedMenuIndex && i2 < this.selectedSubMenuIndex)
        delSubIndex++;
      this.menu.buttons[this.selectedMenuIndex].subButtons.splice(
        delSubIndex,
        1
      );
      this.unSelectMenu();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
@import '~@assets/wx-menu.css';
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
